import React, { forwardRef } from 'react';
import { Icon } from '@chakra-ui/react';
import { QIconProps } from './Icon';
import { QTheme } from '../QTheme';

export const ResourceControl = forwardRef<SVGSVGElement, Partial<QIconProps>>(
  (props, ref) => {
    return (
      <Icon viewBox="0 0 16 16" {...props} ref={ref}>
        <svg fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="16" height="16" rx="2" fill={QTheme.colors.gray[100]} />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.433 3.542c.247 0 .446.2.446.446v3.12a.446.446 0 1 1-.891 0v-3.12c0-.247.2-.446.445-.446m3.567 0c.246 0 .446.2.446.446V5.77h.891a.446.446 0 1 1 0 .892H6.663a.446.446 0 1 1 0-.892h.891V3.988c0-.247.2-.446.446-.446m3.566 0c.247 0 .446.2.446.446V8a.446.446 0 1 1-.891 0V3.988c0-.247.2-.446.445-.446M8 7.554c.246 0 .446.2.446.446v4.012a.446.446 0 0 1-.892 0V8c0-.246.2-.446.446-.446M2.65 8.892c0-.247.2-.446.446-.446h2.675a.446.446 0 1 1 0 .891h-.892v2.675a.446.446 0 0 1-.891 0V9.337h-.892a.446.446 0 0 1-.446-.445m7.133.891c0-.246.2-.446.446-.446h2.675a.446.446 0 0 1 0 .892h-.892v1.783a.446.446 0 0 1-.891 0V10.23h-.892a.446.446 0 0 1-.446-.446"
            fill={QTheme.colors.gray[700]}
          />
        </svg>
      </Icon>
    );
  },
);

ResourceControl.displayName = 'ResourceControl';
